import { Controller } from "@hotwired/stimulus";
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ["switch", "label"]
  static values = {
    disableMethod: String,
    disableUrl: String,
    enableMethod: String,
    enableUrl: String,
    state: Boolean
  }

  toggle() {
    if (this.switchTarget.checked) {
      this.enable()
    } else {
      this.disable()
    }
  }

  enable() {
    this.submit(this.enableUrlValue, this.enableMethodValue)
      .then(response => {
        if(response.ok)
          this.stateValue = true
        else
          this.switchTarget.checked = !this.switchTarget.checked
      })
  }

  disable() {
    this.submit(this.disableUrlValue, this.disableMethodValue)
      .then(response => {
        if(response.ok)
          this.stateValue = false
        else
          this.switchTarget.checked = !this.switchTarget.checked
      })
  }

  submit(endpoint, method) {
    return fetch(endpoint, {
      method: method || "PATCH",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
    })
  }
}
